import { createMuiTheme, createPalette } from '@material-ui/core/styles'
import { lightGreen, grey } from '@material-ui/core/colors'
import { identity } from './brand'

const theme = createMuiTheme({
  brand: identity,
  typography: {
    htmlFontSize: 10,
    fontFamily: "'futura-pt',sans-serif;",
    fontWeightLight: 300,
    fontWeightRegular: 100,
    fontWeightMedium: 500,
  },
  palette: {
    success: lightGreen[500],
    soft: grey[400],
    softer: grey[200],
    grey: grey
  }
})

export default theme



// WEBPACK FOOTER //
// ./src/themes/default/default.theme.js